import { inject, Service } from '@angular/core';
import { AuthApiService } from '@portal-core/auth/services/auth-api.service';
import { CoreDataService } from '@portal-output/core/services/core-data.service';
import { Observable } from 'rxjs';

/**
 * The site-aware AuthApiService used by portal-output, registered over the base in core.providers.
 *
 * Both endpoints below are routed under a `{siteKey}` segment, which the server uses to resolve the
 * site. Only this app knows the key - it comes from CoreDataService - so these overrides are the only
 * working implementations; the base versions omit the segment and match no route.
 */
@Service()
export class AuthSiteApiService extends AuthApiService {
  private readonly coreDataService = inject(CoreDataService);

  override requestPasswordReset$(email: string): Observable<void> {
    const siteKey = this.coreDataService.getSiteKey();
    return this.http.post<void>(`${this.apiService.centralApiBaseUri}/api/users/${siteKey}/ForgotPassword`, null, {
      params: { email }
    });
  }

  override requestSiteAccess$(): Observable<void> {
    const siteKey = this.coreDataService.getSiteKey();
    return this.http.post<void>(`${this.apiService.centralApiBaseUri}/api/users/${siteKey}/RequestSiteAccess`, null);
  }
}
